// extracted by mini-css-extract-plugin
export default {"productGallery":"UL-z","inQuickShop":"VL-z"};